var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('div',[_c('link',{attrs:{"src":"https://cdn.jsdelivr.net/npm/vuetify@3.1.5/dist/vuetify.min.css","rel":"stylesheet"}}),_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }